<template>
	<div>
		<PageHeader
			:data="{
				name: 'Municipality Contacts',
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Municipalities', to: '/municipalities' },
				],
			}"
		/>
		<router-link class="btn btn-primary mb-2" :to="'/municipalities'"> 🏙️ Municipalities </router-link>
		<router-link class="btn btn-primary mb-2 ms-2 active" :to="'/contacts'"> 📙 Municipalities Contacts </router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipality-map'"> 📍 Map </router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipalities-missing'"> Municipalities Missing </router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipality-map/polygons'"> 📐 Map Polygons </router-link>
		<div v-if="!error" class="row mb-3">
			<!-- Filters -->
			<div class="col-12 mb-2">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-center">
							<div class="header d-flex align-items-center">
								<h4 class="p-0 m-0 me-2"><font-awesome-icon :icon="['fas', 'filter']" class="text-primary me-1" /> Filters</h4>
								<button v-if="Object.values(this.params).length > 4 && searchActive === ''" @click="clearFilters()" class="btn btn-sm btn-danger text-white me-2">
									Clear
									<font-awesome-icon :icon="['fas', 'times']" />
								</button>
								<button v-if="!searchSaving && haveParamsToSave() && searchActive === ''" @click="searchSaving = true" class="btn btn-sm btn-primary">
									Save search
								</button>
								<div v-if="searchSaving && searchActive === ''" class="save-search d-flex">
									<form @submit.prevent="storeSearch" class="d-flex">
										<input type="text" v-model="searchName" class="form-control form-control-sm ms-2" placeholder="enter search name" required />
										<button type="submit" class="btn btn-sm btn-primary ms-1">Save</button>
										<a role="button" @click="searchSaving = false" class="btn btn-sm ms-1"> Cancel </a>
									</form>
								</div>
								<span v-if="searchActive !== ''" class="badge bg-success"
									>{{ searchActive }} <font-awesome-icon role="button" @click="clearFilters()" class="ms-2" :icon="['fas', 'times']"
								/></span>
							</div>
							<div class="action-buttons">
								<button
									data-bs-toggle="offcanvas"
									data-bs-target="#offcanvasSearches"
									aria-controls="offcanvasSearches"
									class="btn btn-outline-secondary btn-sm me-2"
								>
									Saved Searches <font-awesome-icon :icon="['fas', 'save']" class="me-1" />
								</button>
							</div>
						</div>

						<LPDataTableFilters :filters="table.filters" v-on:getFilters="getFilters($event.filters)" />
					</div>
				</div>
			</div>
			<!-- Table data -->
			<div class="col-12 mb-2">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-center">
							<div class="header d-flex align-items-center">
								<h4 class="p-0 m-0 me-2 text-capitalize">{{ model }}</h4>
							</div>

							<div class="action-buttons">
								<button
									data-bs-toggle="offcanvas"
									data-bs-target="#offcanvasTableSettings"
									aria-controls="offcanvasTableSettings"
									class="btn btn-outline-secondary btn-sm"
								>
									Table Settings <font-awesome-icon :icon="['fas', 'cogs']" class="me-1" />
								</button>
							</div>
						</div>
						<table :class="!loading && tableData.length > 0 ? 'table table-hover' : 'table table-hover loading'">
							<LPDataTableThead :thead="table.columns" :userColumns="userColumns" v-on:setOrder="setOrderBy($event.orderBy, $event.direction)" />
							<LPDataTableTbody :userColumns="userColumns" :authUser="authUser" :data="tableData" :tbody="table.columns" :model="model" :route="route" />
						</table>
						<div v-if="!loading && tableData.length === 0" class="col-md-12 text-center">
							<h4>No data available</h4>
						</div>
						<div v-if="loading && tableData.length === 0" class="d-flex justify-content-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
						<div class="table-actions d-flex">
							<button data-bs-toggle="modal" data-bs-target="#exportModal" class="btn btn-success btn-sm me-2 fw-normal">
								Export<font-awesome-icon :icon="['fas', 'file-csv']" class="ms-2" />
							</button>
							<router-link
								v-if="authUser.permissions.includes(model.toUpperCase() + '_IMPORT') && authUser.email.includes('srdjan')"
								:to="`/${route}/import`"
								class="btn btn-primary btn-sm me-2 fw-normal"
							>
								Import <font-awesome-icon :icon="['fas', 'file-csv']" class="ms-2" />
							</router-link>
							<button
								v-if="authUser.permissions.includes('CONTACT_UPDATE')"
								data-bs-toggle="modal"
								data-bs-target="#unsubscribeContactModal"
								class="btn btn-success btn-sm me-2 fw-normal"
							>
								<font-awesome-icon :icon="['fas', 'at']" class="me-2" /> Unsubscribe contact
							</button>
						</div>
						<LPDataTablePagination :pagination="pagination" v-on:getItems="getItems($event.page)" />
					</div>
				</div>
			</div>
		</div>

		<div v-else class="row mb-3">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<div class="alert alert-danger" role="alert">
							{{ error }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for unsubscribe contact for email campaigns -->
		<div class="modal fade" id="unsubscribeContactModal" tabindex="-1" aria-labelledby="unsubscribeContactModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<div class="d-flex flex-column">
							<h5 class="modal-title" id="unsubscribeContactModalLabel">Unsubscribe contact</h5>
							<small>Unsubscribe contact with given email </small>
						</div>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<ContactAdvancedSearch :unsubscribedOnly="true" v-on:setContact="setContact" />

						<div class="mt-2" v-if="contactsToUnsubscribe.length > 0">
							<h5>Selected contacts ({{ contactsToUnsubscribe.length }})</h5>
							<div v-for="contact in contactsToUnsubscribe" :key="contact.id" class="search-item ps-2 pe-2 py-1 d-flex justify-content-between mb-1 py-2">
								<span class="me-2">{{ contact.first_name }} {{ contact.last_name }}</span>
								<span
									>{{ contact.email }}
									<button @click="unsetContact(contact)" class="btn btn-sm btn-danger text-white ms-2">
										<font-awesome-icon :icon="['fas', 'times']" />
									</button>
								</span>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
						<button @click="unsubscribeContacts()" :disabled="contactsToUnsubscribe.length === 0" type="submit" class="btn btn-primary">Unsubscribe</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for adding Data -->
		<div class="modal fade" id="create" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="create()">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">New user</h5>
							<small class="ms-2">User default role is user</small>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<h1>Create {{ model }}</h1>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<button type="submit" class="btn btn-primary">Save</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for adding Filter -->
		<div class="modal fade" id="addFilter" tabindex="-1" aria-labelledby="addFilterLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="addFilter">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Add Filter</h5>
							<small class="ms-2">Adding new filter for {{ this.model }}</small>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body text-center">
							<h1>Will come soon 😉</h1>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<!-- <button type="submit" class="btn btn-primary">Save</button> -->
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for export -->
		<div class="modal fade" id="exportModal" tabindex="-1" aria-labelledby="exportModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Export {{ route }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="form-group mb-2">
							<label for="">Export Type</label>
							<select class="form-select" v-model="newExport.type">
								<option value="csv">CSV</option>
							</select>
						</div>
						<div class="form-group mb-2">
							<label for="">File Name</label>
							<div class="input-group mb-3">
								<input type="text" class="form-control" placeholder="File name" v-model="newExport.filename" />
								<span class="input-group-text" id="basic-addon2">.{{ newExport.type }}</span>
							</div>
						</div>
						<div class="form-group">
							<label for="">Columns to export</label>
							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="newExport.columnsType" value="visible" id="visibleColumnsRadio" checked />
								<label class="form-check-label" for="visibleColumnsRadio"> Export visible columns </label>
							</div>
							<div class="my-2" v-if="newExport.columnsType === 'visible'">
								<div class="d-flex flex-wrap">
									<div :key="'column-available-' + column" v-for="column in newExport.exportColumns" class="mb-2 me-1">
										<span class="badge bg-success">{{ column }}</span>
									</div>
								</div>
							</div>
							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="newExport.columnsType" value="custom" id="customColumnsRadio" />
								<label class="form-check-label" for="customColumnsRadio"> Export custom columns </label>
							</div>
							<div class="my-2" v-if="newExport.columnsType === 'custom'">
								<div class="d-flex flex-wrap">
									<small class="w-100 mb-1">ℹ️ Click on column to include/exclude it from export</small>
									<div :key="'column-available-' + column" v-for="column in newExport.availableColumns" class="mb-2 me-1">
										<span role="button" @click="toggleExportColumn(column)" v-if="newExport.exportColumns.includes(column)" class="badge bg-success">{{
											column
										}}</span>
										<span role="button" @click="toggleExportColumn(column)" v-else class="badge bg-secondary">{{ column }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
						<button v-if="!loadExporting && exportingFile === ''" @click="exportData()" type="submit" class="btn btn-primary">Create Export</button>
						<a v-if="!loadExporting && exportingFile !== ''" @click="downloadExport()" :href="exportingFile" class="btn btn-primary" download> Download </a>

						<button v-if="loadExporting" class="btn btn-primary" type="button" disabled>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Offcanvas for Filters -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasFilters" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Filters settings</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">Filters settings</div>
		</div>

		<!-- Offcanvas for Searches -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasSearches" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Saved searches</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<h4 class="m-0">Your saved searches</h4>
				<p class="p-0"><small>ℹ️ Click on search to apply search filters to table</small></p>
				<div class="table-columns-settings">
					<div class="d-flex flex-wrap">
						<div :key="'user-searches-' + search.id" v-for="search in searches" class="mb-2 me-1">
							<span
								data-bs-toggle="offcanvas"
								data-bs-target="#offcanvasSearches"
								aria-controls="offcanvasSearches"
								role="button"
								@click="applySearch(search)"
								class="badge bg-success"
								>{{ search.name }}</span
							>
						</div>
					</div>
				</div>

				<small>👨‍🏫 Your saved searches for fast applying filters, you can add important ones to display above table (🚧 coming soon)</small>
			</div>
		</div>
		<!-- Offcanvas for Table Settings -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasTableSettings" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel" class="text-capitalize">{{ route }} settings</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<h4 class="m-0">Display columns</h4>
				<p class="p-0"><small>ℹ️ Select which columns to display in table</small></p>
				<div class="table-columns-settings">
					<div class="d-flex flex-wrap">
						<div :key="'column-available-' + column" v-for="column in availableColumns" class="mb-2 me-1">
							<span role="button" @click="toggleUserColumn(column)" v-if="userColumns.includes(column)" class="badge bg-success">{{ column }}</span>
							<span role="button" @click="toggleUserColumn(column)" v-else class="badge bg-secondary">{{ column }}</span>
						</div>
					</div>
				</div>

				<small>👨‍🏫 Selected columns are automatically saved to your browser storage and will be used again when you come on this page</small>

				<h4 class="mt-3">Display {{ this.route }} per page</h4>
				<p class="p-0">
					<small>ℹ️ Select how many {{ this.route }} to display per page in table</small>
				</p>
				<div class="form-group w-75">
					<select v-model="userPerPage" @change="setUserPerPage()" class="form-select">
						<option value="10">10 per page</option>
						<option value="15">15 per page</option>
						<option value="20">20 per page</option>
						<option value="30">30 per page</option>
						<option value="50">50 per page</option>
						<option value="100">100 per page</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { Modal } from 'bootstrap'
import { handleErrors } from '../../actions/helpers'
import LPDataTablePagination from '@/components/lp-data-table/LPDataTablePagination'
import LPDataTableFilters from '@/components/lp-data-table/LPDataTableFilters'
import LPDataTableThead from '@/components/lp-data-table/LPDataTableThead'
import LPDataTableTbody from '@/components/lp-data-table/LPDataTableTbody'
import ContactAdvancedSearch from '@/components/contact/ContactAdvancedSearch'

export default {
	name: 'Contacts',
	components: {
		PageHeader,
		LPDataTablePagination,
		LPDataTableFilters,
		LPDataTableThead,
		LPDataTableTbody,
		ContactAdvancedSearch,
	},
	data() {
		return {
			route: 'contacts',
			model: 'contact',
			tableData: [],
			loading: false,
			error: '',
			newTableEntry: {},
			$createModal: null,
			$exportModal: null,
			$addFilterModal: null,
			$unsubscribeContactModal: null,
			pagination: {},
			page: this.$route.query.page || 1,
			orderBy: this.$route.query.orderBy || 'contacts.id',
			direction: this.$route.query.direction || 'asc',
			userPerPage: localStorage.getItem('contact-per-page') || 20,
			table: {
				columns: [
					{
						name: 'id',
						label: 'ID',
						sort: true,
						type: 'default',
					},
					{
						name: 'full_name',
						label: 'Municipality',
						sort: true,
						type: 'default',
					},
					{
						name: 'population',
						label: 'Population',
						sort: true,
						type: 'default',
					},
					{
						name: 'state',
						label: 'State',
						sort: true,
						type: 'default',
					},
					{
						name: 'first_name',
						label: 'First Name',
						sort: false,
						type: 'default',
					},
					{
						name: 'last_name',
						label: 'Last Name',
						sort: false,
						type: 'default',
					},
					{
						name: 'email',
						label: 'Email',
						sort: false,
						type: 'default',
					},
					{
						name: 'phone',
						label: 'Phone',
						sort: false,
						type: 'default',
					},
					{
						name: 'address',
						label: 'Address',
						sort: true,
						type: 'default',
					},
					{
						name: 'title',
						label: 'Title',
						sort: true,
						type: 'default',
					},
					{
						name: 'status',
						label: 'Status',
						sort: true,
						type: 'default',
					},
					{
						name: 'source',
						label: 'Source',
						sort: false,
						type: 'default',
					},
					{
						name: 'website_type',
						label: 'Website Type',
						sort: false,
						type: 'default',
					},
					{
						name: 'nutshell_id',
						label: 'Nutshell ID',
						sort: false,
						type: 'default',
					},
					{
						name: 'nutshell_url',
						label: 'Nutshell URL',
						sort: false,
						type: 'default',
					},
					{
						name: 'created_at',
						label: 'Created',
						sort: false,
						type: 'default',
					},
					{
						name: 'updated_at',
						label: 'Updated',
						sort: false,
						type: 'default',
					},
					{
						name: 'actions',
						label: 'Actions',
						sort: false,
						type: 'actions',
						width: '100px',
						buttons: [
							{
								type: 'default',
								label: 'View',
								action: '',
								class: 'btn-secondary',
								permission: `CONTACT_ACCESS`,
							},
							{
								type: 'default',
								label: 'Edit',
								action: '',
								class: 'btn-primary',
								permission: `CONTACT_UPDATE`,
							},
						],
					},
				],
				filters: [
					{
						display: true,
						name: 'search',
						label: 'Search',
						type: 'text',
						placeholder: 'enter text and press enter',
						colClass: 'col-3',
						value: this.$route.query.search || '',
					},
					{
						display: true,
						name: 'type',
						label: 'Type',
						type: 'select',
						placeholder: 'All types',
						colClass: 'col-2',
						value: this.$route.query.type || '',
						options: [
							{
								id: 'Town',
								name: 'Town',
							},
							{
								id: 'City',
								name: 'City',
							},
							{
								id: 'Township',
								name: 'Township',
							},
							{
								id: 'Village',
								name: 'Village',
							},
							{
								id: 'Borough',
								name: 'Borough',
							},
						],
					},
					{
						display: true,
						name: 'state',
						label: 'State',
						type: 'multiselect',
						placeholder: 'All states',
						colClass: 'col-3',
						options: [],
						optionValue: true,
						optionsEndpoint: `municipalities/states`,
						value: this.$route.query.state || [],
					},
					{
						display: true,
						name: 'county',
						label: 'County',
						type: 'multiselect',
						placeholder: 'All counties',
						colClass: 'col-4',
						options: [],
						value: this.$route.query.county || [],
					},
					{
						display: true,
						name: 'population',
						label: 'Population',
						type: 'range',
						placeholder: '',
						colClass: 'col-3',
						min: 0,
						max: 99999999,
						from: this.$route.query.frompopulation || '',
						to: this.$route.query.topopulation || '',
					},
					{
						display: true,
						name: 'tw_customer',
						label: 'Town Web Customer',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.tw_customer || '',
						options: [
							{
								id: '0',
								name: 'No',
							},
							{
								id: '1',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'hg_customer',
						label: 'HeyGov Customer',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.hg_customer || '',
						options: [
							{
								id: '0',
								name: 'No',
							},
							{
								id: '1',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'deliverable',
						label: 'Address deliverable',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.deliverable || '',
						options: [
							{
								id: '0',
								name: 'No',
							},
							{
								id: '1',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'food_stamp',
						label: 'Food Stamp',
						type: 'range',
						placeholder: '%',
						colClass: 'col-3',
						min: 0,
						max: 100,
						from: this.$route.query.fromfood_stamp || '',
						to: this.$route.query.tofood_stamp || '',
					},
					{
						display: true,
						name: 'norbert_bounced',
						label: 'Norbert bounced',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.norbert_bounced || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'unsubscribed',
						label: 'Unsubscribed',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.unsubscribed || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'source',
						label: 'Source',
						type: 'text',
						placeholder: '',
						colClass: 'col-2',
						value: this.$route.query.source || '',
					},
					{
						display: true,
						name: 'competitor',
						label: 'Competitor',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.competitor || '',
						options: [
							{
								id: 'GovOffice',
								name: 'GovOffice',
							},
							{
								id: 'CivicPlus',
								name: 'CivicPlus',
							},
						],
					},
					{
						display: true,
						name: 'competitor_hg',
						label: 'Competitor HeyGov',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.competitor_hg || '',
						options: [
							{
								id: 'PSN',
								name: 'PSN',
							},
						],
					},
					{
						display: true,
						name: 'title',
						label: 'Title',
						type: 'text',
						placeholder: '',
						colClass: 'col-2',
						value: this.$route.query.title || '',
					},
					{
						display: true,
						name: 'website_type',
						label: 'Website Type',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.website_type || '',
						options: [
							{
								id: 'any',
								name: 'Any',
							},
							{
								id: 'has_website',
								name: 'Has Website',
							},
							{
								id: 'none',
								name: 'No Website',
							},
							{
								id: 'gov',
								name: '.gov Website',
							},
							{
								id: 'non_gov',
								name: 'Non-.gov Website',
							},
						],
					},
				],
			},
			params: {},
			userColumns: JSON.parse(localStorage.getItem(`contact-columns`)) || [
				'id',
				'full_name',
				'population',
				'state',
				'first_name',
				'last_name',
				'title',
				'email',
				'website_type',
				'status',
				'actions',
			],
			availableColumns: ['id'],
			searchName: '',
			searchSaving: false,
			searchActive: '',
			searches: [],
			newExport: {
				type: 'csv',
				columnsType: 'visible',
				filename: '',
				availableColumns: ['id'],
				exportColumns: JSON.parse(localStorage.getItem(`contact-columns`)) || [
					'id',
					'full_name',
					'population',
					'state',
					'first_name',
					'last_name',
					'title',
					'email',
					'website_type',
					'status',
					'actions',
				],
			},
			loadExporting: false,
			exportingFile: '',
			toSync: 1,
			contactsToUnsubscribe: [],
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.table.filters.forEach(filter => {
			if (filter.value && filter.value !== '' && filter.value.length > 0) {
				this.params[filter.name] = filter.value
			} else {
				delete this.params[filter.name]
			}

			if (filter.from && filter.from !== '' && filter.to && filter.to !== '') {
				this.params['from' + filter.name] = filter.from
				this.params['to' + filter.name] = filter.to
			} else {
				delete this.params['from' + filter.name]
				delete this.params['to' + filter.name]
			}
		})
		this.getCountyOptions()
		this.getTableColumns()
		this.getTableData(true)
		this.getSearches()
	},
	mounted() {
		this.$createModal = new Modal('#create')
		this.$addFilterModal = new Modal('#addFilter')
		this.$exportModal = new Modal('#exportModal')
		this.$unsubscribeContactModal = new Modal('#unsubscribeContactModal')
	},
	methods: {
		// Get table Columns
		getTableColumns() {
			restApi
				.post('/helper/table-columns', { table: this.route })
				.then(({ data }) => {
					this.newExport.availableColumns = data.map(column => column.name)
					this.newExport.availableColumns.push('full_name')
					this.newExport.availableColumns.push('population')
					this.newExport.availableColumns.push('state')
					this.newExport.availableColumns.push('website_type')
					this.availableColumns = data.map(column => column.name)
					this.availableColumns.push('full_name')
					this.availableColumns.push('population')
					this.availableColumns.push('state')
					this.availableColumns.push('website_type')
					this.availableColumns.push('actions')
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		// Get table data from API
		getTableData(first = false) {
			this.loading = true

			this.params = {
				...this.params,
				page: this.page,
				orderBy: this.orderBy,
				direction: this.direction,
				perPage: localStorage.getItem(`${this.model}-per-page`) || 20,
			}

			restApi
				.get(`/${this.route}`, { params: this.params })
				.then(({ data }) => {
					this.tableData = data.data
					this.pagination = data
					delete this.pagination.data
					this.loading = false
					if (!first) {
						this.$router.push({ path: this.$router.currentPath, query: this.params })
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Adding new filter
		addFilter() {
			this.$addFilterModal.hide()
		},

		// Go to user page
		viewUser(user) {
			this.$router.push('/users/' + user.id)
		},

		// Get items from page that returned from LPDataTablePagination
		getItems(page) {
			this.page = page
			this.getTableData()
		},

		// Set direction
		setOrderBy(orderBy, direction) {
			this.orderBy = orderBy
			this.direction = direction
			this.getTableData()
		},

		// Get filters from LPDataTableFilters component
		getFilters(filters) {
			this.page = ''
			this.searchActive = ''
			filters.forEach(filter => {
				if (filter.value && filter.value !== '' && filter.value.length > 0) {
					this.params[filter.name] = filter.value
				} else {
					delete this.params[filter.name]
				}

				// Setting filter if its type is range
				if (filter.from && filter.from !== '' && filter.to && filter.to !== '') {
					this.params['from' + filter.name] = filter.from
					this.params['to' + filter.name] = filter.to
				} else {
					delete this.params['from' + filter.name]
					delete this.params['to' + filter.name]
				}
			})
			this.getCountyOptions()
			this.getTableData()
		},

		// Toggle user column
		toggleUserColumn(column) {
			if (this.userColumns.includes(column)) {
				this.userColumns = this.userColumns.filter(c => c !== column)
			} else {
				this.userColumns.push(column)
			}
			this.updateUserColumns()
		},

		// Update user columns
		updateUserColumns() {
			localStorage.setItem(`${this.model}-columns`, JSON.stringify(this.userColumns))
		},

		// Get user saved searches
		getSearches() {
			let params = {
				user_id: this.authUser.id,
				model: this.model,
			}
			restApi
				.get('/searches', { params })
				.then(({ data }) => {
					data.forEach(d => {
						d.data = JSON.parse(d.data)
						return d
					})
					this.searches = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Enable saving if some filters are set
		haveParamsToSave() {
			if (Object.values(this.params).length > 4) {
				return true
			} else {
				return false
			}
		},

		// Get user saved searches
		storeSearch() {
			let dataParams = this.params
			restApi
				.post('/searches', {
					user_id: this.authUser.id,
					model: `${this.model}`,
					name: this.searchName,
					data: JSON.stringify(dataParams),
				})
				.then(({ data }) => {
					data.data = JSON.parse(data.data)
					this.searches.push(data)
					this.searchActive = this.searchName
					this.searchSaving = false
					this.$swal.fire({
						icon: 'success',
						title: 'Search successfully saved!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Apply saved search to table
		applySearch(search) {
			// Reset all before applying saved search
			this.params = {}
			this.table.filters.forEach(filter => {
				if (filter.type !== 'range' && filter.type !== 'daterange') {
					filter.value = ''
				} else {
					filter.from = ''
					filter.to = ''
				}
			})
			// Apply saved search
			this.params = search.data
			let paramsArray = Object.keys(search.data)
			this.table.filters.forEach(filter => {
				if (paramsArray.includes(filter.name) && filter.type !== 'range') {
					filter.value = this.params[filter.name]
				}
				if (paramsArray.includes('from' + filter.name) && filter.type === 'range') {
					filter.from = this.params['from' + filter.name]
					filter.to = this.params['to' + filter.name]
				}
				if (paramsArray.includes('from' + filter.name) && filter.type === 'daterange') {
					filter.from = this.params['from' + filter.name]
					filter.to = this.params['to' + filter.name]
				}
			})
			this.searchActive = search.name
			this.getTableData()
		},

		// Clear all filters
		clearFilters() {
			this.params = {}
			this.searchActive = ''
			this.table.filters.forEach(filter => {
				if (filter.type !== 'range' && filter.type !== 'multiselect') {
					filter.value = ''
				}
				if (filter.type === 'multiselect') {
					filter.value = []
				}
				if (filter.type === 'range' || filter.type === 'daterange') {
					filter.from = ''
					filter.to = ''
				}
			})
			this.getCountyOptions()
			this.getTableData()
		},

		// Toggle export column
		toggleExportColumn(column) {
			if (this.newExport.exportColumns.includes(column)) {
				this.newExport.exportColumns = this.newExport.exportColumns.filter(c => c !== column)
			} else {
				this.newExport.exportColumns.push(column)
			}
		},

		// Export table Data
		exportData() {
			this.loadExporting = true
			this.newExport.exportColumns = this.newExport.exportColumns.filter(column => column !== 'actions')
			restApi
				.post(`/${this.route}/export`, {
					params: JSON.stringify(this.params),
					columns: JSON.stringify(this.newExport.exportColumns),
					filename: this.newExport.filename,
				})
				.then(({ data }) => {
					this.loadExporting = false
					this.exportingFile = this.storageUrl + '/tmp/' + data.file
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Download exported Data
		downloadExport() {
			this.$exportModal.hide()
			this.newExport.filename = ''
			this.exportingFile = ''
		},

		// Set user per page
		setUserPerPage() {
			localStorage.setItem(`${this.model}-per-page`, this.userPerPage)
			this.getTableData()
		},

		// Get county options for selected state
		getCountyOptions() {
			if (this.params.state) {
				restApi.post('municipalities/counties', { state: this.params.state }).then(({ data }) => {
					data = data.filter(county => county !== null)
					this.counties = data
					let filter = this.table.filters.find(f => f.name === 'county')
					filter.options = data
				})
			} else {
				let filter = this.table.filters.find(f => f.name === 'county')
				filter.options = []
				filter.disabled = true
			}
		},

		// Unsubscribe contacts to not receive emails
		unsubscribeContacts() {
			restApi
				.post('contacts/unsubscribe', { contacts: this.contactsToUnsubscribe })
				.then(({ data }) => {
					this.$unsubscribeContactModal.hide()
					this.contactsToUnsubscribe = []
					this.$swal.fire({
						icon: 'success',
						title: data.message,
						timer: 3000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Set contact from contact advanced search to contacts array
		setContact(contact) {
			if (!this.contactsToUnsubscribe.find(c => c.id === contact.id)) {
				this.contactsToUnsubscribe.push(contact)
			} else {
				this.$swal.fire({
					icon: 'error',
					title: 'You already added this email',
					timer: 2000,
				})
			}
		},

		// Remove contact
		unsetContact(contact) {
			this.contactsToUnsubscribe = this.contactsToUnsubscribe.filter(c => c.id !== contact.id)
		},
	},
}
</script>

<style lang="scss">
.search-item {
	display: flex;
	justify-content: center;
	cursor: pointer;
	border-bottom: 1px solid whitesmoke;
	&:hover {
		background-color: whitesmoke;
		border-radius: 0.5rem;
	}
}
</style>
